import ApiService from "../ApiService";
import AppConfig from "../../mobile/config/AppConfig";
import DebugLogger from "../../utils/DebugLogger";
import * as Helper from "../../utils/Helper";
// import LocationHelper from "../../utils/LocationHelper";
import SpeechRecognition from "../../mobile/components/customModule/speechRecognition/SpeechRecognition";
import LocationHelper from "../../utils/LocationHelper";
import RegionServerManager from "../../mobile/utils/RegionServerManager";
import RoomClient from "../../mobile/utils/chinesepark/RoomClient";

const MobileLayoutService = {
    loadApp: (successCallback, failureCallback) => {
        RegionServerManager.instance().loadLocalStore().then(() => {
            ApiService.post(
                "/app/load",
                {},
                response => {
                    let snakeCaseObject = Helper.convertCamelCaseKeysToUpperSnakeCase(response);
                    //update app config
                    DebugLogger.groupMessage("Get New App Config From Server", snakeCaseObject);
                    AppConfig.updateAppConfig(snakeCaseObject);
                    DebugLogger.groupMessage("Update App Config", AppConfig);
                    //recover api server if override by this
                    if (!RoomClient.recoverApiServerIfNeeded()) {
                        if (response.regionServers && response.regionServers.length > 0) {
                            RegionServerManager.instance().setServers(response.regionServers);
                        } else {
                            // once app is loaded, then we want to update api service url since
                            // it could be changed by the server based on the location of client
                            if (!Helper.isNullOrEmpty(response.apiEndPoint)) {
                                AppConfig.APP_SERVICE_BASE = response.apiEndPoint;

                                ApiService.setBaseURL(AppConfig.APP_SERVICE_BASE);
                            }

                            if (!Helper.isNullOrEmpty(response.fileServerEndPoint)) {
                                AppConfig.FILE_SERVER = response.fileServerEndPoint;
                            }

                            if (!Helper.isNullOrEmpty(response.proxyEndPoint)) {
                                AppConfig.PROXY_SERVICE_BASE = response.proxyEndPoint;
                            }

                            if (!Helper.isNullOrEmpty(response.nodeServerEndPoint)) {
                                AppConfig.NODE_SERVICE_BASE = response.nodeServerEndPoint;
                            }

                            if (!Helper.isNullOrUndefined(response.regionServerSpeechRecognizeServiceType) && response.regionServerSpeechRecognizeServiceType !== -1) {
                                AppConfig.SPEECH_RECOGNIZE_SERVICE_TYPE = response.regionServerSpeechRecognizeServiceType;
                            }

                            if (!Helper.isNullOrUndefined(response.regionServerSpeechReviewServiceType) && response.regionServerSpeechReviewServiceType !== -1) {
                                AppConfig.SPEECH_RECOGNIZE_SERVICE_REVIEW_TYPE = response.regionServerSpeechReviewServiceType;
                            }

                            if (!Helper.isNullOrUndefined(response.regionServerSpeechRecognizeUseProxyServer) && response.regionServerSpeechRecognizeUseProxyServer !== -1) {
                                AppConfig.SPEECH_RECOGNIZE_USE_PROXY_SERVER = response.regionServerSpeechRecognizeUseProxyServer;
                            }
                        }
                    }

                    if (!Helper.isNullOrEmpty(response.aliYunIntToken) && !Helper.isNullOrEmpty(response.aliYunToken) && !Helper.isNullOrEmpty(response.singSoundToken)) {
                        const { aliYunIntToken, aliYunToken, singSoundToken } = response;
                        SpeechRecognition.setToken({ aliYunIntToken, aliYunToken, singSoundToken });
                    }

                    LocationHelper.initIsInChina();


                    if (successCallback) successCallback(response);
                },
                error => {
                    RegionServerManager.instance().clearLocalStore();
                    if (failureCallback) failureCallback(error);
                },
            );
        });
    },
};

export default MobileLayoutService;
